module.exports = __webpack_public_path__ + "img/sidebar_2bundesliga_202627.288f6364.png";